import { createReducer, on } from '@ngrx/store';

import { Stage, StatusState, UpgradeError } from '../../interfaces';
import { AuthActions, DataActions, StatusActions, UpgradeActions } from '../actions';

export const initialState: StatusState = {
  error: UpgradeError.none,
  pending: false,
  stage: Stage.LOGIN,
  userLoggedIn: false,
  waitlisted: false,
  splitPNR: false,
};

const statusReducer = createReducer(
  initialState,
  on(StatusActions.setStage, StatusActions.setStage, (state, { stage }) => ({
    ...state,
    stage,
  })),
  on(AuthActions.setLoggedIn, (state, { loggedIn }) => ({
    ...state,
    userLoggedIn: loggedIn,
  })),
  on(AuthActions.setBookingRef, UpgradeActions.upgradeFlights, (state) => ({
    ...state,
    error: UpgradeError.none,
    pending: true,
  })),
  on(AuthActions.setUpgradeData, (state) => ({
    ...state,
    error: UpgradeError.none,
    pending: false,
  })),
  on(StatusActions.setError, (state, { error }) => ({
    ...state,
    error: error,
  })),
  on(StatusActions.clearErrors, (state) => ({
    ...state,
    error: UpgradeError.none,
  })),
  on(StatusActions.clearPending, (state) => ({
    ...state,
    pending: false,
  })),
  on(StatusActions.setWaitlisted, (state, { waitlisted }) => ({
    ...state,
    waitlisted,
  })),
  on(StatusActions.setSplitPNR, (state, { splitPNR }) => ({
    ...state,
    splitPNR,
  })),
  on(AuthActions.logout, () => initialState)
);

type actionType =
  | AuthActions.AuthActionsUnion
  | StatusActions.StatusActionsUnion
  | UpgradeActions.UpgradeActionsUnion
  | DataActions.DataActionsUnion;

export function reducer(state: StatusState, action: actionType): StatusState {
  return statusReducer(state, action);
}

export const getError = (state: StatusState): UpgradeError => state.error;
export const getPending = (state: StatusState): boolean => state.pending;
export const getStage = (state: StatusState): Stage => state.stage;
export const getUserLoggedIn = (state: StatusState): boolean => state.userLoggedIn;
export const getWaitlisted = (state: StatusState): boolean => state.waitlisted;
export const getSplitPNR = (state: StatusState): boolean => state.splitPNR;
